import { render, staticRenderFns } from "./XmlPolisher.vue?vue&type=template&id=41520c2c&"
import script from "./XmlPolisher.vue?vue&type=script&lang=ts&"
export * from "./XmlPolisher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports